// extracted by mini-css-extract-plugin
export default {"body":"hvsff"};